import React from 'react';
import UseOurProductsPage from './UseOurProductsPage';
import ProductFilter from './Components/ProductFilter';
import { FaIndianRupeeSign } from 'react-icons/fa6';
import config from '../../../../config/environment';
import { Link } from 'react-router-dom';
import { AiOutlineHome } from 'react-icons/ai';
import { FaChevronRight } from 'react-icons/fa6';
import Namsteji_Manikchand_Icon from '../../../../assets/images/Namsteji_Manikchand_Icon.svg';
import { FaArrowLeft } from 'react-icons/fa';
import ProductsPageHelmet from '../../../HelmetComponents/ProductsPageHelmet';

const OurProductsPage: React.FC = () => {
  const { states, goToProductDetailsPage, navigate, customerId } = UseOurProductsPage();
  const serverUrl = config.SERVER_URL;
  return (
    <>
      <ProductsPageHelmet />
      <div className=' bg-[#F5F5F5] py-8 px-4 hidden sm:hidden md:hidden lg:block xl:block'>
        <nav className='flex items-center text-base gap-2 mx-[8%]'>
          <Link to='/home'>
            <AiOutlineHome className='text-black font-semibold size-6 cursor-pointer hover:text-[#4A2D1A]' />
          </Link>
          <FaChevronRight className='text-black font-semibold size-3' />
          <span className='text-black text-base font-rubik'>Our Product</span>
        </nav>
      </div>
      <div className='flex items-center justify-center my-2 sm:my-2 md:my-2 lg:my-4 '>
        <div className='mx-[.5%] sm:mx-[.5%] md:mx-[1%] lg:mx-[8%] p-3 sm:p-3 md:p-2 lg:p-4'>
          <div className='hidden lg:flex justify-center'>
            <h1 className='text-3xl font-bold text-[#4A2D1A] mb-4'>Our Products</h1>
          </div>

          {/* For small and medium screens: Arrow + title */}
          <div className='flex lg:hidden items-center gap-2 mb-4'>
            <FaArrowLeft onClick={() => navigate(-1)} className='w-[17px] h-[16px] text-[#4A2D1A]' />
            <h2 className='text-lg  font-bold text-[#4A2D1A]'>Our Products</h2>
          </div>

          <ProductFilter
            itemGroup={states.itemGroups}
            selectedFilter={states.selectedFilter}
            onSelect={states.setSelectedFilter}
          />
          <div className='grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-2 md:gap-6 lg:gap-6'>
            {states.filteredProducts.map((product, index) => (
              <div
                key={index}
                onClick={() => goToProductDetailsPage(product?.item_code)}
                className='cursor-pointer bg-white rounded-xl drop-shadow-xl hover:drop-shadow-2xl transition-shadow duration-300 p-2 sm:p-2 md:p-4 lg:p-4 flex flex-col'
              >
                <img
                  src={product.website_image ? serverUrl + product.website_image : Namsteji_Manikchand_Icon}
                  alt='Manikchand Product'
                  className='min-h-[12rem] max-h-[12rem] min-w-40 max-w-80 
                    sm:min-h-[12rem] sm:max-h-[12rem] sm:min-w-40 sm:max-w-80
                    md:min-h-[16rem] md:max-h-64 md:min-w-48 md:max-w-[24rem]
                    lg:min-h-[18rem] lg:max-h-[18rem] lg:min-w-48 lg:max-w-[28rem]'
                />
                <div>
                  <h3 className='text-xs sm:text-xs md:text-lg lg:text-lg font-bold sm:font-bold md:font-semibold lg:font-semibold font-poppins'>
                    {product.item_name}
                  </h3>
                  {product.uom_conversion?.find((u: any) => u.uom === 'Nos')?.conversion_factor && (
                    <p className='text-[10px] sm:text-[10px] md:text-sm lg:text-sm text-[#000000] sm:text-[#000000] md:text-gray-500 lg:text-gray-500 font-poppins'>
                      Pack of {product.uom_conversion.find((u: any) => u.uom === 'Nos')?.conversion_factor}
                    </p>
                  )}
                  {customerId && customerId.current && customerId.current !== '' && (
                    <div className='flex items-center justify-between mt-0 sm:mt-0 md:mt-1 lg:mt-1'>
                      <div className='flex items-center font-poppins text-black font-medium text-[10px] sm:text-[10px] md:text-xl lg:text-xl ml-0 sm:ml-0  md:-ml-1 lg:-ml-1'>
                        <FaIndianRupeeSign className='text-xs sm:text-xs md:text-base lg:text-base' />
                        <span className='text-xs sm:text-xs md:text-lg lg:text-lg pr-0 sm:pr-0 md:pr-1 lg:pr-1 font-poppins font-semibold sm:font-semibold md:font-semibold lg:font-medium'>
                          {product.web_price ? Number(product.web_price).toFixed(2) : '00.00'}
                        </span>
                        <div className='flex items-center text-gray-400'>
                          <FaIndianRupeeSign className='text-[9px] sm:text-[9px] md:text-sm lg:text-sm' />
                          <span className='font-poppins line-through text-[9px] sm:text-[9px] md:text-sm lg:text-sm'>
                            {product.formatted_mrp ? Number(product.formatted_mrp).toFixed(2) : '00:00'}
                          </span>
                        </div>
                      </div>
                      <div className='flex items-center'>
                        <button
                          onClick={() => goToProductDetailsPage(product?.item_code)}
                          className='px-2 sm:px-2 md:px-3.5 lg:px-3.5 py-1 border border-[#C12E2A] text-[#C12E2A] rounded-md sm:rounded-md md:rounded-lg lg:rounded-lg hover:bg-red-100 transition text-[9px] sm:text-[9px] md:text-sm lg:text-sm font-medium font-poppins'
                        >
                          Buy Now
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default OurProductsPage;
